export default {
  userMediaWrapper: { display: 'flex', flexDirection: 'column', gap: 1.5 },
  userMediaButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
